import { createContext, useContext, useMemo } from 'react';

const ShellConfigContext = createContext(null);

const DEFAULTS = {
  homePath: '/dashboard/default',
  buildMenu: () => ({ items: [] }),
  HeaderExtras: null,
  Banner: null
};

export function ShellConfigProvider({ value, children }) {
  const merged = useMemo(
    () => ({
      ...DEFAULTS,
      ...value
    }),
    [value]
  );
  return <ShellConfigContext.Provider value={merged}>{children}</ShellConfigContext.Provider>;
}

export function useShellConfig() {
  return useContext(ShellConfigContext) ?? DEFAULTS;
}
